import axios from 'axios';
import { initialize } from 'redux-form';

import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';

export const FINANCEIRO_AGUARDANDO = 'FINANCEIRO_AGUARDANDO';
export const FINANCEIRO_MODO = 'FINANCEIRO_MODO';
export const FINANCEIRO_LISTA = 'FINANCEIRO_LISTA';
export const FINANCEIRO_OPCOES = 'FINANCEIRO_OPCOES';

const caminho = tipo =>
    tipo === 'PAGAR' ? 'contaPagar' : 'contaReceber';

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return null;
    }

    const texto = valor.toString().trim();
    const possuiMilhar = /^-?\d{1,3}(\.\d{3})+$/.test(texto);
    const normalizado = texto.includes(',') || possuiMilhar
        ? texto.replace(/\./g, '').replace(',', '.')
        : texto;
    const resultado = Number(normalizado);

    return Number.isFinite(resultado) ? resultado : null;
};

const hoje = () => {
    const data = new Date();
    data.setMinutes(data.getMinutes() - data.getTimezoneOffset());
    return data.toISOString().substring(0, 10);
};

const dataInput = valor => valor
    ? valor.toString().substring(0, 10)
    : null;

const normalizar = (tipo, registro) => ({
    ...registro,
    id_plano_conta: Number(registro.id_plano_conta) || null,
    id_forma_pagamento:
        Number(registro.id_forma_pagamento) || null,
    quantidade_parcelas:
        Number(registro.quantidade_parcelas) || 1,
    id_cliente: tipo === 'RECEBER'
        ? Number(registro.id_cliente) || null
        : null,
    id_fornecedor: tipo === 'PAGAR'
        ? Number(registro.id_fornecedor) || null
        : null,
    valor_original: numero(registro.valor_original),
    valor_baixado: numero(registro.valor_baixado) || 0,
    data_baixa: numero(registro.valor_baixado) > 0
        ? registro.data_baixa
        : null
});

export const setAguardando = aguardando => ({
    type: FINANCEIRO_AGUARDANDO,
    payload: aguardando
});

export const setModo = (tipo, modo, registro = {}) => ({
    type: FINANCEIRO_MODO,
    payload: { tipo, modo, registro }
});

export function initForm(tipo, registro = {}) {
    const dataAtual = hoje();

    return initialize(`financeiroForm${tipo}`, {
        descricao: '',
        valor_original: 0,
        valor_baixado: 0,
        data_emissao: dataAtual,
        data_vencimento: dataAtual,
        quantidade_parcelas: 1,
        ...registro,
        id_plano_conta:
            Number(registro.id_plano_conta) || null,
        id_forma_pagamento:
            Number(registro.id_forma_pagamento) || null,
        quantidade_parcelas:
            Number(registro.quantidade_parcelas) || 1,
        id_cliente: Number(registro.id_cliente) || null,
        id_fornecedor: Number(registro.id_fornecedor) || null,
        valor_original: numero(registro.valor_original) || 0,
        valor_baixado: numero(registro.valor_baixado) || 0,
        data_emissao:
            dataInput(registro.data_emissao) || dataAtual,
        data_vencimento:
            dataInput(registro.data_vencimento) || dataAtual,
        data_baixa: dataInput(registro.data_baixa)
    });
}

export function getLista(tipo) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const resposta = await axios.get(
                `${consts.API_URL}/${caminho(tipo)}`
            );

            dispatch({
                type: FINANCEIRO_LISTA,
                payload: { tipo, lista: resposta.data }
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getOpcoes(tipo) {
    return async dispatch => {
        try {
            const resposta = await axios.get(
                `${consts.API_URL}/financeiro/opcoes`,
                { params: { tipo } }
            );

            dispatch({
                type: FINANCEIRO_OPCOES,
                payload: { tipo, opcoes: resposta.data }
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function salvar(tipo, registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const dados = normalizar(tipo, registro);
            const url = `${consts.API_URL}/${caminho(tipo)}`;

            if (dados.id) {
                await axios.put(url, dados);
            } else {
                await axios.post(url, dados);
            }

            setSuccess(
                dados.id
                    ? 'Lançamento atualizado.'
                    : 'Lançamento incluído.'
            );
            dispatch(getLista(tipo));
            dispatch(setModo(tipo, 'lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function cancelar(tipo, registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            await axios.delete(
                `${consts.API_URL}/${caminho(tipo)}`,
                { params: { id: registro.id } }
            );

            setSuccess('Lançamento cancelado.');
            dispatch(getLista(tipo));
            dispatch(setModo(tipo, 'lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
